// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Ni_W","right":"styles_right__2avZ5"};